import type { PhoneCode } from './schema'

/** Indonesia reference id from `/v1/reference/phone-codes` (matches Android + robojastip). */
export const FALLBACK_INDONESIA_PHONE_CODE_ID = 17

export const INDONESIA_DIAL_CODE = '+62'

export function resolvePhoneCodeId(
  codes: PhoneCode[],
  dialCode = INDONESIA_DIAL_CODE,
): number {
  const normalized = dialCode.startsWith('+') ? dialCode : `+${dialCode}`
  const match = codes.find((item) => item.dialCode === normalized)
  return match?.id ?? FALLBACK_INDONESIA_PHONE_CODE_ID
}
